import BarItem from '@/features/pos/components/ProductCatalog/parts/CategoryBar/parts/BarItem'
import Collapsible from '@/features/pos/components/ProductCatalog/parts/CategoryBar/parts/CategoryWithSubcategories/parts/Subcategories/parts/Collapsible'
import {
    MeasureItemLeftPosition,
    Subcategory as SubcategoryData,
} from '@/features/pos/components/ProductCatalog/parts/CategoryBar/types'
import { FC, RefObject } from 'react'
import { Platform, View } from 'react-native'
import { DerivedValue } from 'react-native-reanimated'

interface SubcategoriesProps {
    subcategories: SubcategoryData[]
    selectedId?: string
    expanded: DerivedValue<boolean>
    horizontal?: boolean
    onPress: (id: string, measureItemLeftPosition: MeasureItemLeftPosition) => void
    ref: RefObject<View | null>
}

const Subcategories: FC<SubcategoriesProps> = ({
    subcategories,
    selectedId,
    expanded,
    horizontal = false,
    onPress,
    ref,
}) => {
    return (
        <Collapsible expanded={expanded} horizontal={horizontal} ref={ref}>
            {subcategories.map(({ id, name }) => (
                /* wrapper view prevents single item from getting collapsed on Android */
                <View
                    key={id}
                    style={Platform.select({ android: { flex: 1 }, default: undefined })}
                    collapsable={false}
                >
                    <BarItem
                        type="subcategory"
                        selected={id === selectedId}
                        id={id}
                        onPress={onPress}
                    >
                        {name}
                    </BarItem>
                </View>
            ))}
        </Collapsible>
    )
}

export default Subcategories
